module.exports = __webpack_public_path__ + "pc/img/icon4.ae31073c.png";